export class UserSalaryHistoryModel {
    user_salary_history_id: number;
    user_id: number;
    role_title: string;
    salary_brl: number;
    start_date: string | Date;
    end_date: string | Date | null;
    observation: string | null;
    created_by_user_id: number | null;
    createdAt: Date;

    constructor(data?: Partial<UserSalaryHistoryModel>) {
        this.user_salary_history_id = data?.user_salary_history_id ?? null;
        this.user_id = data?.user_id ?? null;
        this.role_title = data?.role_title ?? null;
        this.salary_brl = data?.salary_brl != null ? Number(data.salary_brl) : null;
        this.start_date = data?.start_date ?? null;
        this.end_date = data?.end_date ?? null;
        this.observation = data?.observation ?? null;
        this.created_by_user_id = data?.created_by_user_id ?? null;
        this.createdAt = data?.createdAt ?? null;
    }
}
